/**
 * streamlines add a dynamic value to padding-left.
 * @param {object} param0
 * @param {number|string} param0.$paddingLeft
 * @returns {string}
 */
const dynPaddingLeft = ({ $paddingLeft }) => {
  if ($paddingLeft === undefined) return "";
  if (typeof $paddingLeft === "number")
    return `padding-left: ${$paddingLeft}px;`;
  return `padding-left: ${$paddingLeft};`;
};

export default dynPaddingLeft;
